export class InvalidArgumentException extends Error {}
